import users from '@/api/security/users'
import {
  transform,
  groupBy,
  uniq,
  map,
  head,
  capitalize,
  sortBy,
  lowerCase
} from 'lodash'

import { baseState, baseMutations } from '@/store/mixins'

const getPermissionOrder = suffix => {
  switch (lowerCase(suffix)) {
    case 'view':
      return 0

    case 'create':
      return 1

    case 'update':
      return 2

    case 'delete':
      return 3

    default:
      return 4
  }
}

export const state = {
  ...baseState,
  employees: [],
  warehouses: [],
  permissions: [],
  branches: [],
  counters: [],
  searchPermissionText: ''
}

export const getters = {
  permissionGroups: state => {
    const permissions = state.permissions.filter(p => {
      return (
        p.name
          .toLowerCase()
          .includes(state.searchPermissionText.toLowerCase()) ||
        (p.group !== null &&
          p.group
            .toLowerCase()
            .includes(state.searchPermissionText.toLowerCase()))
      )
    })

    return transform(
      groupBy(permissions, permission => capitalize(permission.group)),
      (result, value, key) => {
        result[key] = groupBy(
          sortBy(value, p => getPermissionOrder(head(p.name.split('-')))),
          permission => capitalize(permission.resource)
        )
      },
      {}
    )
  },
  permissionColumns: state => {
    return sortBy(
      uniq(
        map(state.permissions, p => {
          return capitalize(head(p.name.split('-')))
        })
      ),
      p => getPermissionOrder(p)
    )
  }
}

export const mutations = {
  ...baseMutations,
  RECEIVE_PERMISSIONS(state, permissions) {
    state.permissions = permissions.map(permission => {
      return {
        id: permission.id,
        name: permission.name,
        resource: permission.label,
        group: permission.group
      }
    })
  },
  SET_SEARCH_PERMISSION(state, searchPermissionText) {
    state.searchPermissionText = searchPermissionText
  },
  SET_BRANCHESE(state, data) {
    state.branches = data
  },
  SET_COUNTER(state, data) {
    state.counters = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
        }
      },
      attrubutes
    )
    return users.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return users.store(data)
  },
  update(context, { id, ...data }) {
    return users.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await users.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  getRole(context) {
    return users.role({
      params: {
        filter: {
          guard_name: 'api-admin'
        }
      }
    })
  },
  fetchPermissions(context, attributes) {
    if (context.state.permissions.length > 0) return

    return users.permission({
      params: Object.assign({}, attributes)
    }).then(response => {
      context.commit('RECEIVE_PERMISSIONS', response.data)
      return Promise.resolve(response)
    })
  },
  passwordReset(context, { id, data }) {
    return users.passwordReset(id, data)
  },
  async branch(context) {
    let response = await users.branch()
    context.commit('SET_BRANCHESE', response.data)
    return Promise.resolve(response)
  },
  getBranchAssigned(context) {
    return users.branchAssigned()
  },
  getWarehouseAssigned(context, attrubutes = {}) {
    return users.warehouseAssigned({ params: attrubutes })
  },
  employee(context) {
    return users.employee()
  },
  unlock(context, data) {
    return users.unlock(data)
  },
  changePassword(context, data) {
    return users.changePassword(data)
  },
  getMobileRole(context) {
    return users.mobileRole()
  },
  getReportTo(context, parentId) {
    return users.reportTo(parentId)
  },
  async getGetCounter(context) {
    let response = await users.counter()
    context.commit('SET_COUNTER', response.data)
  },
  getBranchAssignedForFilter(context) {
    return users.branchAssignedForFilter()
  },
  getWarehouseAssignedForFilter(context, attrubutes = {}) {
    return users.warehouseAssignedForFilter({ params: attrubutes })
  },
}
